<template>
  <div v-if="cameras.length > 0">
    <div class="accordion mx-1" role="tablist">
      <b-alert show variant="info" class="p-1 seproban-summary">
        <div v-if="camerasSummary">
          <div v-if="alarm.id_seproban_alarm" class="seproban-summary-actions">
            <b-button
              :to="{
                name: 'seproban_images',
                params: { id_event: alarm.id_seproban_alarm },
              }"
              size="sm"
              variant="link"
              class="seproban-action-button"
              :title="$t('seproban.view_detail')"
              :aria-label="$t('seproban.view_detail')"
            >
              <feather-icon icon="ExternalLinkIcon" size="18" />
            </b-button>
            <b-button
              v-if="canSendImages"
              size="sm"
              variant="link"
              class="seproban-action-button text-success"
              :disabled="downloadingTarget !== null"
              :title="$t('actions.download')"
              :aria-label="$t('actions.download')"
              @click="downloadSnapshots()"
            >
              <b-spinner v-if="downloadingTarget === 'all'" small />
              <feather-icon v-else icon="DownloadCloudIcon" size="18" />
            </b-button>
          </div>
          <div><strong>Camaras:</strong> {{ cameras.length }}</div>
          <div><strong>Total imágenes:</strong> {{ totalImages }}</div>
          <div>
            <strong>{{ $t("seproban.generated_images") }}:</strong>
            {{ generatedImagesCount }}
          </div>
          <div>
            <strong>{{ $t("seproban.sent_images") }}:</strong>
            {{ sentImagesCount }}
          </div>
          <div><strong>Inicio imagen:</strong> {{ camerasSummary.start_time ? camerasSummary.start_time.toLocaleString() : '' }}</div>
          <div><strong>Última imagen:</strong> {{ camerasSummary.last_sent ? camerasSummary.last_sent.toLocaleString() : '' }}</div>
          <div>
            <strong class="text-capitalize">{{ $tc("region.title", 1) }}:</strong>
            <span class="text-capitalize">
              {{ alarm.unit && alarm.unit.region ? alarm.unit.region.name : "-" }}
            </span>
          </div>
          <div>
            <strong class="text-capitalize">{{ $tc("municipality.title", 1) }}:</strong>
            <span class="text-capitalize">
              {{ alarm.unit && alarm.unit.municipality ? alarm.unit.municipality.name : "-" }}
            </span>
          </div>
          <div>
            <strong>{{ $t("seproban.first_download_at") }}:</strong>
            {{ seprobanStats.firstDownloadedAt }}
          </div>
          <div>
            <strong>{{ $t("seproban.last_download_at") }}:</strong>
            {{ seprobanStats.lastDownloadedAt }}
          </div>
          <div>
            <strong>{{ $t("seproban.first_sent_at") }}:</strong>
            {{ seprobanStats.firstSentAt }}
          </div>
          <div>
            <strong>{{ $t("seproban.last_sent_at") }}:</strong>
            {{ seprobanStats.lastSentAt }}
          </div>
          <div>
            <strong>{{ $t("seproban.send_rate") }}:</strong>
            {{ seprobanStats.sendRate }}
            <span v-if="seprobanStats.sendRate !== '-'">
              {{ $t("seproban.images_per_second") }}
            </span>
          </div>
          <div v-if="!allUploadsComplete" class="mt-1">
            <b-button
              block
              size="sm"
              variant="primary"
              @click="sendImagesToSeproban()"
            >
              {{ sending ? $t("seproban.sending") + '...' : $t("seproban.send_seproban") }}
            </b-button>
          </div>
        </div>
      </b-alert>
      <b-card
        v-for="camera in cameras"
        :key="camera.camera_proxy_id"
        no-body
        class="mb-1"
      >
        <!-- ESTADO: DESCARGANDO -->
        <template>
          <div class="seproban-download-progress-row">
            <div class="seproban-download-progress-content">
              <span>
                {{ $t("seproban.fetching_images") + ' (' + (camera.images.length || 0) + '/' + alarm.total_images / cameras.length + ')' }}
              </span>
              <b-progress
                :value="(camera.download_progress || 0)"
                :key="'progress-download-' + camera.id_alarm + '-' + camera.camera_proxy_id"
                height="5px"
              />
            </div>
            <b-button
              v-if="Number(camera.download_progress) >= 100 && alarm.id_seproban_alarm"
              size="sm"
              variant="outline-success"
              class="seproban-camera-download"
              :disabled="downloadingTarget !== null"
              :title="$t('actions.download')"
              :aria-label="$t('actions.download')"
              @click.stop="downloadSnapshots(camera.camera_proxy_id)"
            >
              <b-spinner
                v-if="downloadingTarget === camera.camera_proxy_id"
                small
              />
              <feather-icon v-else icon="DownloadCloudIcon" size="15" />
            </b-button>
          </div>
        </template>
        <template v-if="camera.upload_progress">
          <span>
            {{ $t("seproban.upload_finished") + ' (' + (camera.sent_images || 0) + '/' + alarm.total_images / cameras.length + ')' }}
          </span>
          <b-progress
            :value="(camera.upload_progress || 0)"
            :key="'progress-upload-' + camera.id_alarm + '-' + camera.camera_proxy_id"
            height="5px"
          />
        </template>
        <!-- ESTADO: DESCARGA COMPLETA Y AÚN NO SE ENVÍAN IMAGENES -->
        <!--<template
          v-else-if="!uploadStarted[camera.camera_proxy_id] && (camera.upload_progress || 0) === 0"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ $t("seproban.capture_completed") }}</span>
          </div>
        </template>-->
        <!-- ESTADO: SUBIENDO -->
        <!--<template
          v-else-if="
            uploadStarted[camera.camera_proxy_id] &&
            (camera.upload_progress || 0) < 100
          "
        >
          <span>{{ $t("seproban.uploading_images") }}</span>
          <b-progress
            :value="camera.upload_progress || 0"
            :key="'progress-upload-' + camera.id_alarm + '-' + camera.camera_proxy_id"
            animated
            height="5px"
          />
        </template>-->
        <!-- ESTADO: SUBIDA COMPLETA -->
        <!--<template v-else-if="camera.upload_progress >= 100">
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ $t("seproban.upload_finished") }}</span>
          </div>
        </template>-->

        <b-card-header
          header-tag="header"
          class="p-1 d-flex align-items-center"
          role="tab"
        >
          <b-button
            block
            v-b-toggle="'accordion-' + usageType + '-' + camera.id_alarm + '-' + camera.camera_proxy_id"
            variant="info"
            class="btn-sm mb-0"
          >
            {{ camera.camera_name }}
            <span
              :class="[
                'arrow-icon',
                { rotated: openCameraId === camera.camera_proxy_id },
              ]"
            >
              ▼
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          :id="'accordion-' + usageType + '-' + camera.id_alarm + '-' + camera.camera_proxy_id"
          accordion="my-accordion"
          role="tabpanel"
          @show="openCameraId = camera.camera_proxy_id"
          @hide="openCameraId = null"
        >
          <b-card-body>
            <div
              class="image-grid"
              v-if="getCameraImages(camera.camera_proxy_id).length"
            >
              <b-img
                v-for="(image, index) in getCameraImages(
                  camera.camera_proxy_id
                )"
                :key="index"
                :src="image.url"
                fluid
                :alt="`Imagen ${index + 1}`"
                class="image-thumbnail"
                @click="openImageModal(camera.camera_proxy_id)"
                v-b-modal.image_modal
              />
            </div>
            <div v-else class="text-center text-muted">
              {{ $t("seproban.no_images_available") }}
            </div>
          </b-card-body>
        </b-collapse>

        <!--<template>
          <span>{{ $t("seproban.uploading_images") }}</span>
          <b-progress
            :value="camera.upload_progress === 0 ? 100 : camera.upload_progress"
            :key="'progress-upload-' + camera.id_alarm + '-' + camera.camera_proxy_id"
            :animated="camera.upload_progress === 0"
            height="5px"
          />
        </template>-->
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BCollapse,
  BProgress,
  BImg,
  BSpinner,
} from "bootstrap-vue";
import { ref, computed, watch, onMounted } from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import moment from "moment-timezone";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BCollapse,
    BProgress,
    BImg,
    BSpinner,
  },
  props: {
    alarmId: {
      type: Number,
      required: true,
    },
    usageType: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const sending = ref(false);
    const openCameraId = ref(null);
    const uploadStarted = ref({});
    const user = store.getters["user/getUser"];
    const alarm = ref(null);
    const downloadingTarget = ref(null);

    onMounted(() => {

      const alarmInStore = store.state.send_to_seproban.items.alarms.find(
        (a) => a.id_alarm === props.alarmId
      );

      if (alarmInStore) {
        alarm.value = alarmInStore;
        return; 
      }

      if (props.usageType === "slot") {
        loadAlarmFromAPI();
      }
    });

    const loadAlarmFromAPI = async () => {
      try {
        const response = await axios.get("/v1/seproban/events", {
          params: {
            id_alarm: props.alarmId,
            with_snapshots: true,
            max: 1,
            sortBy: "id",
            sortDesc: true,
          },
        });
        const event = response.data.data?.[0];

        if (!event) {
          return;
        }

        alarm.value = {
          ...event,
          created: event.alarm_created_at,
          unit_name: event.unit?.description,
          total_images: event.total_snapshots,
        };

        if (!alarm.value.id_alarm) {
          return;
        }

        store.commit("send_to_seproban/initAlarm", {
          alarmId: alarm.value.id_alarm,
          seprobanAlarmId: alarm.value.id,
          unitName: alarm.value.unit_name,
          unit: event.unit,
          created: alarm.value.created,
          totalImages: alarm.value.total_images,
          event,
        });

        const cameras = alarm.value.cameras.map((cam) => ({ ...cam }));

        store.commit("send_to_seproban/setFilteredCameras", {
          alarmId: alarm.value.id_alarm,
          cameras: cameras,
        });
      } catch (error) {
        console.error(error);
      }
    };

    const cameras = computed(() => {
      if (!alarm.value) return [];
      return alarm.value.cameras.map((camera) => ({
        ...camera,
        id_alarm: alarm.value.id_alarm,
      }));
    });

    const canSendImages = computed(() => {
      return (
        cameras.value.length > 0 &&
        cameras.value.every((camera) => Number(camera.download_progress) >= 100)
      );
    });

    const allUploadsComplete = computed(() => {
      return (
        cameras.value.length > 0 &&
        cameras.value.every((camera) => camera.upload_progress >= 100)
      );
    });

    const camerasSummary = computed(() => {
      if (!cameras.value || cameras.value.length === 0) {
        return {
          total_images: 0,
          start_time: null,
          last_sent: null,
        };
      }

      const allImages = cameras.value.flatMap(cam => cam.images || []);
      const total_images = allImages.length;
      const timestamps = allImages.map(img => new Date(img.timestamp).getTime());
      const start_time = timestamps.length ? new Date(Math.min(...timestamps)) : null;
      const last_sent = timestamps.length ? new Date(Math.max(...timestamps)) : null;

      return {
        total_images,
        start_time,
        last_sent,
      };
    });

    const totalImages = computed(() => {
      return Number(alarm.value.total_images);
    });

    const generatedImagesCount = computed(() => cameras.value.reduce(
      (total, camera) => total + (Number(camera.downloaded_images) || 0),
      0
    ));

    const sentImagesCount = computed(() => cameras.value.reduce(
      (total, camera) => total + (Number(camera.sent_images) || 0),
      0
    ));

    const parseDate = value => {
      if (!value) return null;
      const date = new Date(typeof value === "string" ? value.replace(" ", "T") : value);
      return Number.isNaN(date.getTime()) ? null : date;
    };

    const formatStatDate = date => date ? date.toLocaleString() : "-";

    const seprobanStats = computed(() => {
      const allImages = cameras.value.reduce(
        (result, camera) => result.concat(Array.isArray(camera.images) ? camera.images : []),
        []
      );
      const downloadedDates = [
        alarm.value.first_snapshot_downloaded_at,
        alarm.value.last_snapshot_downloaded_at,
      ]
        .concat(cameras.value.map(camera => camera.last_snapshot_downloaded_at))
        .concat(allImages.map(image => image.last_snapshot_downloaded_at || image.download_at))
        .map(parseDate)
        .filter(Boolean);
      const sentDates = [
        alarm.value.first_snapshot_sent_at,
        alarm.value.last_snapshot_sent_at,
        alarm.value.sent_seproban_at,
        alarm.value.sent_at,
      ]
        .concat(cameras.value.map(camera => camera.sent_seproban_at || camera.sent_at))
        .concat(allImages.map(image => image.sent_seproban_at || image.sent_at || image.uploaded_at))
        .map(parseDate)
        .filter(Boolean);
      const firstSentDate = sentDates.length ? new Date(Math.min(...sentDates)) : null;
      const lastSentDate = sentDates.length ? new Date(Math.max(...sentDates)) : null;
      const elapsedSeconds = firstSentDate && lastSentDate
        ? (lastSentDate.getTime() - firstSentDate.getTime()) / 1000
        : 0;
      const imagesPerSecond = sentImagesCount.value > 0 && elapsedSeconds > 0
        ? sentImagesCount.value / elapsedSeconds
        : null;

      return {
        firstDownloadedAt: formatStatDate(downloadedDates.length ? new Date(Math.min(...downloadedDates)) : null),
        lastDownloadedAt: formatStatDate(downloadedDates.length ? new Date(Math.max(...downloadedDates)) : null),
        firstSentAt: formatStatDate(firstSentDate),
        lastSentAt: formatStatDate(lastSentDate),
        sendRate: imagesPerSecond === null ? "-" : imagesPerSecond.toFixed(2),
      };
    });

    watch(
      cameras,
      (newVal) => {
        emit("has-seproban-data", newVal.length > 0);
      },
      { immediate: true }
    );

    const getCameraImages = (cameraId) => {
      const camera = cameras.value.find((c) => c.camera_proxy_id === cameraId);
      return camera?.images || [];
    };

    const openImageModal = async (cameraId) => {

      const camera = cameras.value.find(c => c.camera_proxy_id === cameraId);
      const unitName = alarm.value?.unit_name ?? "UNKNOWN";
      const cameraName = camera.camera_name ?? "UNKNOWN";

      const images = getCameraImages(cameraId).map((img) => ({
        ...img,
        url: img.url,
        unit_name: unitName,
        camera_name: cameraName,
        date: img.timestamp,
      }));

      if (images.length) {
        await store.dispatch("image_modal/imageList", images);
      }
    };

    const sendImagesToSeproban = async () => {
      sending.value = true;
      const cameraIds = cameras.value.map((camera) => camera.camera_proxy_id);
      cameraIds.forEach((cameraId) => {
        uploadStarted.value = { ...uploadStarted.value, [cameraId]: true };
      });

      setSnapshotsUploadSeprobanWS();

      const dateCreated = alarm.value.created;
      const date = moment(dateCreated, "YYYY-MM-DD HH:mm:ss");
      const dataBefore = date.clone().subtract(1, "minutes");
      const dateAfter = date.clone().add(1, "minutes");

      const startDate = dataBefore.format("YYYY-MM-DD HH:mm:ss");
      const endDate = dateAfter.format("YYYY-MM-DD HH:mm:ss");

      let params = {
        ids_camera_proxy: cameraIds,
        start_date: startDate,
        end_date: endDate,
        id_alarm: props.alarmId,
      };

      try {
        await axios.post("/v1/seproban/snapshots/upload", params);
      } catch (error) {
        sending.value = false;
        console.error("Error al subir las imágenes:", error);
      }
    };

    const downloadSnapshots = async (cameraProxyId = null) => {
      if (!alarm.value?.id_seproban_alarm || downloadingTarget.value !== null) {
        console.log("downloadSnapshots", alarm.value, downloadingTarget.value)
        return;
      }

      downloadingTarget.value = cameraProxyId ?? "all";
      try {
        await store.dispatch("seproban_images/downloadZip", {
          id_seproban_alarm_event: alarm.value.id_seproban_alarm,
          ...(cameraProxyId != null ? { id_camera_proxy: cameraProxyId } : {}),
        });
      } finally {
        downloadingTarget.value = null;
      }
    };

    const setSnapshotsUploadSeprobanWS = () => {
      window.Echo.leave(`snapshots-upload-seproban-${user.id}-${props.alarmId}`);

      window.Echo.private(`snapshots-upload-seproban-${user.id}-${props.alarmId}`).listen(".process", (data) => {

          store.commit("send_to_seproban/updateUploadData", {
            alarmId: data.alarm_id,
            cameraId: data.camera_proxy_id,
            imageUrl: data.image_url,
            progress: data.progress,
            timestamp: data.sent_at || data.uploaded_at || Date.now(),
          });
          console.log('snapshots-upload-seproban', data)
        }
      );
    };

    /*const getElapsed = (start, end) => {
      if (!start || !end) return "--";

      const s = new Date(start);
      const e = new Date(end);

      const diffMs = e - s; // Diferencia en milisegundos
      if (diffMs < 0) return "--";

      const totalSec = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;

      return `${hours}h ${minutes}m ${seconds}s`;
    }*/

    return {
      sending,
      cameras,
      openCameraId,
      uploadStarted,
      canSendImages,
      allUploadsComplete,
      getCameraImages,
      openImageModal,
      sendImagesToSeproban,
      camerasSummary,
      alarm,
      totalImages,
      generatedImagesCount,
      sentImagesCount,
      seprobanStats,
      downloadingTarget,
      downloadSnapshots,

      //getElapsed,
    };
  },
};
</script>

<style lang="scss" scoped>
.arrow-icon {
  transition: transform 0.3s ease;
  display: inline-block;
  margin-left: 8px;
}

.rotated {
  transform: rotate(180deg);
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
}

.image-thumbnail {
  object-fit: cover;
  width: 100%;
  height: 100px;
  border-radius: 4px;
}

.seproban-summary {
  position: relative;
  padding-right: 4.5rem !important;
}

.seproban-summary-actions {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  align-items: center;
}

.seproban-action-button {
  padding: 0.25rem;
  line-height: 1;
}

.seproban-download-progress-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.seproban-download-progress-content {
  flex: 1 1 auto;
  min-width: 0;
}

.seproban-camera-download {
  flex-shrink: 0;
  padding: 0.35rem 0.75rem;
}
</style>
